import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import farmsConfig from 'config/constants/farms'
import TokensConfig from 'config/constants/tokens'
import calcFarmsPrices from 'state/farms/calcFarmsPrices'

import type { SerializedFarmsState, SerializedFarm, FarmUserDataResponse } from 'state/types'

export const coreFarms = farmsConfig.filter(
  (farm) =>
    (farm.token.symbol === TokensConfig.usdc.symbol && farm.quoteToken.symbol === TokensConfig.wcro.symbol) ||
    (farm.token.symbol === TokensConfig.vvs.symbol && farm.quoteToken.symbol === TokensConfig.wcro.symbol),
)

const noAccountFarmConfig = farmsConfig.map((farm) => {
  const config = {
    ...farm,
    loaded: false,
    userData: {
      allowance: '0',
      tokenBalance: '0',
      stakedBalance: '0',
      earnings: '0',
      boostRewards: '0',
      boostRewardsAllFarms: '0',
      loaded: false,
    },
  }
  if (farm.version === 2) {
    const tokens = [TokensConfig.vvs.address]
    const earnings = ['0']

    if (farm.rewarders) {
      farm.rewarders.forEach((rewarder) => {
        tokens.push(rewarder.token.address)
        earnings.push('0')
      })
    }

    Object.assign(config.userData, { earningsV2: { tokens, earnings } })
    return config
  }
  return config
})

const initialState: SerializedFarmsState = {
  data: noAccountFarmConfig,
  loadArchivedFarmsData: false,
  allUserDataLoaded: false,
}

export const farmsSlice = createSlice({
  name: 'Farms',
  initialState,
  reducers: {
    setFarmsPublicData: (state, action: PayloadAction<SerializedFarm[]>) => {
      const farmsDataWithoutVvsPool = action.payload.filter((farm: SerializedFarm) => {
        return farm.pid || farm.pid === 0
      })
      const farmsWithPrices = calcFarmsPrices(farmsDataWithoutVvsPool, state.data)

      state.data = state.data.map((currentFarmData) => {
        const newFarmData = farmsWithPrices.find(
          (farmData) => farmData.pid === currentFarmData.pid && farmData.version === currentFarmData.version,
        )
        if (!newFarmData) return currentFarmData // keep unchanged SerializedFarm stable
        return { ...currentFarmData, ...newFarmData, loaded: true }
      })
    },
    setFarmsUserData: (state, action: PayloadAction<FarmUserDataResponse[]>) => {
      action.payload.forEach((userDataEl) => {
        const { pid, version } = userDataEl
        const index = state.data.findIndex((farm) => farm.pid === pid && farm.version === version)
        if (index !== -1) {
          state.data[index] = { ...state.data[index], userData: { ...userDataEl, loaded: true } }
        }
      })
      state.allUserDataLoaded = state.data.every((f) => f.userData.loaded)
    },
    setLoadArchivedFarmsData: (state, action) => {
      const loadArchivedFarmsData = action.payload
      state.loadArchivedFarmsData = loadArchivedFarmsData
    },
  },
})

// Actions
export const { setFarmsPublicData, setFarmsUserData, setLoadArchivedFarmsData } = farmsSlice.actions

export default farmsSlice.reducer
